import { render, staticRenderFns } from "./ProductManagementSendToStock.vue?vue&type=template&id=563cf0b6&scoped=true"
import script from "./ProductManagementSendToStock.vue?vue&type=script&lang=js"
export * from "./ProductManagementSendToStock.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementSendToStock.vue?vue&type=style&index=0&id=563cf0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563cf0b6",
  null
  
)

export default component.exports